import GatewayService from '@/service/gateway-service';
import { PRODUCT_COLLECTIONS } from '@/views/product/gql';

export default class ViewProductUtils {
  /**
   *
   * @param {number} discountValue
   * @param {string} currency
   * @param {Object} product
   * @param {boolean} enableSubscriptionStrikethrough
   * @param {boolean} enableOneTimeStrikethrough
   * @param {number} maxPrice
   */
  static addStrikethroughPrices({
    discountValue,
    currency,
    product,
    enableSubscriptionStrikethrough,
    enableOneTimeStrikethrough,
    maxPrice
  }) {
    const originalPrice = maxPrice ?? product?.price_max;
    const discountRatio = ((originalPrice * discountValue) / 10000).toFixed(2);
    const discountedPrice = (originalPrice / 100 - discountRatio) * 100;
    const isUsd = currency === 'USD';

    enableSubscriptionStrikethrough &&
      ViewProductUtils.addStrikethroughSubscription({
        originalPrice,
        isUsd,
        discountedPrice
      });

    ViewProductUtils.addStrikethroughOneTime({
      isUsd,
      ...(enableOneTimeStrikethrough
        ? {
            originalPrice,
            discountedPrice
          }
        : { discountedPrice: originalPrice, originalPrice: 0 })
    });
  }

  /**
   *
   * @param {number} originalPrice
   * @param {boolean} isUsd
   * @param {number} discountedPrice
   */

  static addStrikethroughSubscription({
    originalPrice,
    isUsd,
    discountedPrice
  }) {
    const rcTextElement = document.querySelector('.rc-radio__subscription');

    document.querySelector('.rc-radio__price').classList.add('hidden');

    const formattedInitialPrice = isUsd
      ? `${Shopify.formatMoney(
          originalPrice,
          window.theme.moneyFormat
        )}`.replace(/\s/g, '')
      : `${Shopify.formatMoney(
          originalPrice,
          window.theme.moneyWithCurrencyFormat
        )}`.replace(/\s/g, '');

    const formattedDiscountedPrice = isUsd
      ? `${Shopify.formatMoney(
          discountedPrice,
          window.theme.moneyFormat
        )}`.replace(/\s/g, '')
      : `${Shopify.formatMoney(
          discountedPrice,
          window.theme.moneyWithCurrencyFormat
        )}`.replace(/\s/g, '');

    const priceContainer = document.getElementById('price-container');
    const htmlContent = ViewProductUtils.getPriceHtmlContent({
      formattedVariantPrice: formattedInitialPrice,
      formattedDiscountedPrice
    });
    if (!priceContainer) {
      const priceHtml = document.createElement('span');
      priceHtml.id = 'price-container';
      priceHtml.innerHTML = htmlContent;
      rcTextElement.after(priceHtml);
    } else {
      priceContainer.innerHTML = htmlContent;
    }
  }

  /**
   *
   * @param {number} originalPrice
   * @param {boolean} isUsd
   * @param {number | undefined} discountedPrice
   */
  static addStrikethroughOneTime({ originalPrice, isUsd, discountedPrice }) {
    const oneTimeContainer = document.querySelector('.onetime-radio');
    const oneTimeLabel = oneTimeContainer.querySelector('.rc-radio__label');
    const oneTimeLabelValues = oneTimeLabel.innerText.split(/[\s\n]+/);
    const labelName = document.createElement('span');
    const labelPrice = document.createElement('span');

    const formattedVariantPrice = originalPrice
      ? isUsd
        ? `${Shopify.formatMoney(originalPrice, window.theme.moneyFormat)}`
        : `${Shopify.formatMoney(
            originalPrice,
            window.theme.moneyWithCurrencyFormat
          )}`
      : '';

    const formattedDiscountedPrice = isUsd
      ? `${Shopify.formatMoney(discountedPrice, window.theme.moneyFormat)}`
      : `${Shopify.formatMoney(
          discountedPrice,
          window.theme.moneyWithCurrencyFormat
        )}`;

    labelName.className = 'name';
    labelName.textContent = `${oneTimeLabelValues[0]}`;

    labelPrice.id = 'one-time-price-container';
    labelPrice.innerHTML = ViewProductUtils.getPriceHtmlContent({
      formattedVariantPrice,
      formattedDiscountedPrice
    });

    oneTimeLabel.textContent = '';
    oneTimeLabel.appendChild(labelName);
    oneTimeLabel.appendChild(labelPrice);
  }

  static getPriceHtmlContent({
    formattedVariantPrice,
    formattedDiscountedPrice
  }) {
    return `
                <div style="display: flex; gap: 4px;">
                    <div class="initial">
                        ${formattedVariantPrice}
                    </div>
                    <div class="discounted">
                        ${formattedDiscountedPrice}
                    </div>
                </div>`;
  }

  /**
   *
   * @param {{handle: string,title: string }} product
   * @param settings{object}
   * @returns {Promise<*|boolean>}
   */
  static async isProductSpecificDiscount({ product, settings }) {
    const specificProductDiscountList =
      settings?.specific_product_discount_list;
    const specificCollectionDiscountList =
      settings?.specific_collection_discount_list;

    if (specificProductDiscountList.some((x) => x.title === product.title))
      return true;

    const specificHandles = specificCollectionDiscountList.map((x) => x.handle);
    const productCollection = await GatewayService.getStoreFront().getRequest({
      query: PRODUCT_COLLECTIONS,
      variables: { handle: product.handle }
    });

    const handles = productCollection.productByHandle
      ? productCollection.productByHandle.collections.edges.map(
          (collection) => collection.node.handle
        )
      : [];

    return handles.some((x) => specificHandles.includes(x));
  }

  /**
   *
   * @param {number} basePriceRaw
   * @returns {string} discountedPrice
   */
  static calculateFWBDiscountedPrice(basePriceRaw) {
    return `$${((basePriceRaw - basePriceRaw * 0.2) / 100).toFixed(2)}`;
  }
}
